var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "client-app" } },
    [
      _c(
        "v-app",
        [
          _vm.isLoading
            ? _c(
                "div",
                {
                  staticClass:
                    "loading-screen fill-height justify-content-center",
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "loading",
                    attrs: { indeterminate: "", color: "green" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Header"),
          _vm._v(" "),
          _c("v-main", { staticClass: "bg-gray" }, [
            _vm.unconfirmedEmail
              ? _c(
                  "div",
                  { staticClass: "p-4", attrs: { fluid: "" } },
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass: "xs12 mb-0",
                        attrs: { value: true, type: "error" },
                      },
                      [
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "【注意】ユーザー編集はまだ終わっていません。"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "確認メールを送信しましたので、メール内のリンクをクリックして変更を有効にしてください。"
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm.guestWarning
              ? _c(
                  "div",
                  { staticClass: "p-4", attrs: { fluid: "" } },
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass: "xs12 mb-0",
                        attrs: { value: true, type: "warning" },
                      },
                      [
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "あなたはゲストユーザーです。ユーザー設定を済ませてください（これを行わないとテスト結果が消えて、次からログインできなくなります）"
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "mb-0" },
                          [
                            _c("span", { staticClass: "me-3" }, [
                              _vm._v(
                                "ユーザー名、メールアドレス、パスワードの設定を行ってください"
                              ),
                            ]),
                            _c(
                              "router-link",
                              { attrs: { to: "/classroom/myprofile" } },
                              [_vm._v("リンク")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: { "p-0": _vm.mobile, "m-2": !_vm.isMeeting } },
              [
                _c(
                  "transition",
                  { attrs: { name: _vm.transitionName, mode: "out-in" } },
                  [_c("router-view")],
                  1
                ),
                _vm._v(" "),
                _vm.mobile &&
                (_vm.$route.name == _vm.ROUTER_NAME.QUESTION ||
                  _vm.$route.name == _vm.ROUTER_NAME.QUESTION_HEADER) &&
                _vm.exam &&
                _vm.answersFlowQuestion
                  ? _c(
                      "div",
                      { staticClass: "answer-footer-mobile" },
                      [
                        _c("ChartProgress", {
                          key:
                            _vm.answersFlowQuestion.length /
                            _vm.exam.questionsIgnoreDescription.length,
                          attrs: {
                            size: 160,
                            series: [
                              (_vm.answersFlowQuestion.length * 100) /
                                _vm.exam.questionsIgnoreDescription.length,
                            ],
                            labelColor: "#2699fb",
                            label:
                              _vm.answersFlowQuestion.length +
                              "/" +
                              _vm.exam.questionsIgnoreDescription.length,
                            subLabel: _vm.$t("question.question", {
                              format: _vm.LETTER_FORMAT.UPTITLECASE,
                            }),
                            chartColor: "#2699fb",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-snackbar",
            {
              attrs: {
                right: true,
                top: true,
                timeout: 3000,
                color: _vm.snackbar.color,
              },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackbar.text) + "\n      "),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeSnackbar } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("common.close", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    )
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("Footer", { attrs: { dataRender: _vm.footerRender } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }